import { loadStripe } from '@stripe/stripe-js';

// Load Stripe
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

export { stripePromise };

// Stripe Price IDs
export const STRIPE_PRICE_MONTHLY = import.meta.env.VITE_STRIPE_PRICE_MONTHLY;
export const STRIPE_PRICE_YEARLY = import.meta.env.VITE_STRIPE_PRICE_YEARLY;

// Legacy export for backward compatibility
export const STRIPE_PRICE_ID = STRIPE_PRICE_MONTHLY;

// Billing interval type
export type BillingInterval = 'monthly' | 'yearly';

// Price display info for both intervals
export const PRICING_INFO = {
  monthly: {
    priceId: STRIPE_PRICE_MONTHLY,
    amount: 3.0,
    currency: 'SGD',
    interval: 'month',
    displayPrice: 'SGD 3.00',
    displayInterval: '/month',
    displayPeriod: 'Monthly',
    totalAnnual: 'SGD 36.00/year',
  },
  yearly: {
    priceId: STRIPE_PRICE_YEARLY,
    amount: 30.0, // Adjust this to your actual yearly price
    currency: 'SGD',
    interval: 'year',
    displayPrice: 'SGD 30.00',
    displayInterval: '/year',
    displayPeriod: 'Yearly',
    savings: 'Save SGD 6.00',
    savingsPercentage: '17%',
    monthlyEquivalent: 'SGD 2.50/month',
  },
};

// Helper function to get pricing info by interval
export const getPricingInfo = (interval: BillingInterval) => {
  return PRICING_INFO[interval];
};
